import React from "react";
import {useTranslation} from "react-i18next";
import {Tabs} from "antd";
import RaceTrack from "./raceTrack";
import RaceVenue from "./RaceVenue";
import RaceCentralizer from "./RaceCentralizer";

export default function RaceTrackAndVenue() {
    const {t} = useTranslation();

    const items = [
        {
            key: '1',
            label: t('Track.Title'),
            children: <RaceTrack />
        },
        {
            key: '2',
            label: t('venue.title'),
            children: <RaceVenue />
        },
        {
            key: '3',
            label: 'Centralizer',
            children: <RaceCentralizer />
        }
    ];

    // render ---------------------------------------------------------
    return (
        <div className="private_page_wrapper">
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    );
}
